module.exports = __webpack_public_path__ + "img/logo-product-bnpl.1e515ac5.svg";